import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=c74db0a8&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=c74db0a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c74db0a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c74db0a8')) {
      api.createRecord('c74db0a8', component.options)
    } else {
      api.reload('c74db0a8', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=c74db0a8&scoped=true&", function () {
      api.rerender('c74db0a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27LnDkt6wb5zl/JS/comp/GuestBox.vue"
export default component.exports